import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  InfoCircleOutlined,
  LogoutOutlined,
  SettingOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Button } from 'antd';

import useTranslation from 'customHooks/translate';
import { useAuth } from 'providers/user-context';
import ContactUsForm from 'pages/Dialogs/ContactUsForm';

import { mobileMenuLinks } from './links';

interface IProps {
  isMenuOpen: boolean;
  toggleMenu: () => void;
  currentAccountData?: any;
}

const MobileMenu = (props: IProps) => {
  const { isMenuOpen, toggleMenu, currentAccountData } = props;

  const translation = useTranslation();
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);

  const handleLogOut = () => {
    logout();
    toggleMenu();
  };

  const handleNavigate = (path: string) => {
    navigate(path);
    toggleMenu();
  };

  return (
    <div
      className={`absolute left-[0px] z-[9] h-[calc(100vh-81px)] w-full bg-white shadow-md ${
        isMenuOpen
          ? 'top-[81px] translate-y-0'
          : 'top-[-100%] hidden -translate-y-full'
      }`}
    >
      <ul className="m-0 list-none px-4">
        {mobileMenuLinks(translation)?.map((mobileMenuLink) => (
          <li
            key={mobileMenuLink?.url}
            className="border-b border-[#eee] py-3 text-[#333]"
          >
            <Link
              className="block text-base font-medium no-underline"
              style={{ fontFamily: 'Mark Pro', fontWeight: '400' }}
              to={mobileMenuLink?.url}
              onClick={toggleMenu}
            >
              {mobileMenuLink?.name}
            </Link>
          </li>
        ))}

        <div className="mt-[10px] flex flex-col gap-[10px]">
          <div className="grid grid-cols-2 gap-[10px]">
            <Link to="/invoices/new" state={{ from: 'debitor' }}>
              <button
                onClick={toggleMenu}
                className="flex w-full items-center justify-center gap-[6px] rounded-md border border-[#6DCD90] px-[20px] py-[8px] text-[14px] font-medium text-[#1D1D1D] transition-all duration-300 ease-in-out hover:bg-gray-100"
              >
                <img
                  src="/assets/new-invoice.svg"
                  alt="icon"
                  className="h-5 w-5"
                />
                <span>{translation.create.InvoiceButton}</span>
              </button>
            </Link>

            <Link to="/cost/new" state={{ from: 'creditor' }}>
              <button
                onClick={toggleMenu}
                className="flex w-full items-center justify-center gap-[6px] rounded-md border border-[#466AFB] px-[20px] py-[8px] text-[14px] font-medium text-[#1D1D1D] transition-all duration-300 ease-in-out hover:bg-gray-100"
              >
                <img
                  src="/assets/new-cost.svg"
                  alt="icon"
                  className="h-5 w-5"
                />
                <span>{translation.create.CostButton}</span>
              </button>
            </Link>
          </div>
          <Button
            type="default"
            className="h-[41px] w-full rounded-md border border-[#466afb] bg-transparent font-semibold text-[#466afb] transition-all duration-300 hover:bg-[#466afb]/10"
            onClick={() => handleNavigate('/profile')}
          >
            <div className="flex items-center justify-center gap-[10px]">
              <UserOutlined />
              {translation.profile.profile}
            </div>
          </Button>
          <Button
            type="default"
            className="h-[41px] w-full rounded-md border border-[#466afb] bg-transparent font-semibold text-[#466afb] transition-all duration-300 hover:bg-[#466afb]/10"
            onClick={() => handleNavigate('/settings')}
          >
            <div className="flex items-center justify-center gap-[10px]">
              <SettingOutlined />
              {translation.ProfileButton.Settings}
            </div>
          </Button>
          <Button
            type="default"
            className="h-[41px] w-full rounded-md border border-[#466afb] bg-transparent font-semibold text-[#466afb] transition-all duration-300 hover:bg-[#466afb]/10"
            onClick={() => {
              setIsContactFormOpen(true);
              toggleMenu();
            }}
          >
            <div className="flex items-center justify-center gap-[10px]">
              <InfoCircleOutlined />
              {translation.checkEmail.ContactLink}
            </div>
          </Button>
          <Button
            type="default"
            danger
            className="h-[41px] w-full rounded-md border border-[#de3e3e] font-semibold text-[#de3e3e] hover:bg-[#de3e3e]/10"
            onClick={handleLogOut}
          >
            <div className="flex items-center justify-center gap-[10px]">
              <LogoutOutlined />
              {translation.ProfileButton.Logout}
            </div>
          </Button>
        </div>
      </ul>
      <ContactUsForm
        open={isContactFormOpen}
        handleClose={() => setIsContactFormOpen(false)}
        currentAccountData={currentAccountData}
      />
    </div>
  );
};

export default MobileMenu;
